<template>
  <table test-id="grid_table">
    <thead>
    <tr>
      <th class="group pax-th">
        Резервная группа
      </th>
      <th class="pax-th">
        Тип расчета
      </th>
      <th class="pax-th">
        Отчетная дата
      </th>
      <th class="pax-th">
        Дата расчета
      </th>
      <th class="pax-th">
        Ответственный
      </th>
      <th class="pax-th">
        Статус расчета
      </th>
      <th class="pax-th">
        Результат
      </th>
    </tr>
    </thead>
    <tbody>
      <tr>
        <td class="type" colspan="7">
          {{ title }}
        </td>
      </tr>
      <tr v-if="items.length > 0">
        <td class="select-all" colspan="7">
          <label for="">
            <input type="checkbox" v-model="selectAllActive" name="" id="" @change="changeGridState">
            Выделить все
          </label>
        </td>
      </tr>
      <GridLine v-for="item in items" :item="item" :key="item.id" @change-state="changeRowState"/>
      <tr v-if="!items.length">
        <td class="no" colspan="7">
          Расчеты не найдены
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import GridLine from '@/components/Dashboard/GridLine'

export default {
  components: {
    GridLine
  },
  props: ['title', 'items'],
  data() {
    return {
      selectAllActive: false,
    }
  },
  watch: {
    items(newItems){
      const checkedItems = newItems.filter(item => item.isChecked);
      if(checkedItems.length === 0) this.selectAllActive = false;
    }
  },
  methods: {
    changeRowState(id) {
      this.$emit('change-state', id)
    },
    changeGridState(e) {
      this.$emit('change-grid', this.items.map(num => num.id), e.target.checked)
    }
  }
}
</script>

<style scoped>
table {
  border-spacing: 0.5rem;
  width: 100%;
  background-color: #ffffff;
  margin-bottom: 1rem;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
}

th {
  text-align: center;
  padding: 0 0.2rem;
  font-weight: normal;
}

.group {
  text-align: left;
  padding-left: 0;
}

.type {
  text-align: left;
  font-weight: bold;
}

.no {
  padding-left: 1rem;
  padding-bottom: 0.3rem;
}

th:nth-child(1),
th:nth-child(5){
  width: 15%;
}

th:nth-child(2),
th:nth-child(6){
  width: 20%;
}

th:nth-child(3),
th:nth-child(4),
th:nth-child(7){
  width: 10%;
}
</style>
